// extracted by mini-css-extract-plugin
export default {"manualTxMainContainer":"ManualTx_manualTxMainContainer__iDVFA","inputContainer":"ManualTx_inputContainer__tTyRx","processButton":"ManualTx_processButton__Ziymm"};